import { render, staticRenderFns } from "./form_categories_marketplace_component.vue?vue&type=template&id=fb205f0e&scoped=true"
import script from "./form_categories_marketplace_component.vue?vue&type=script&lang=js"
export * from "./form_categories_marketplace_component.vue?vue&type=script&lang=js"
import style0 from "./form_categories_marketplace_component.vue?vue&type=style&index=0&id=fb205f0e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb205f0e",
  null
  
)

export default component.exports